import React, { useEffect, useState } from "react";
import { CountryData } from "./CountryData";

// Import only the required components
import EligibilityRequirements from "./EligibilityRequirements";
import ApplicationProcess from "./ApplicationProcess";
import TuitionFees from "./TuitionFees";
import TopUniversities from "./TopUniversities";
import CostOfLiving from "./CostOfLiving";
import ContactUsForm from "../../components/ContactForm";
// import CounselorContact from "./CounselorContact";

export default function CountryOverview({ country }) {
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    const foundCountry = CountryData.find(
      (item) => item.name.toLowerCase() === country.toLowerCase()
    );
    setSelectedCountry(foundCountry);
  }, [country]);

  if (!selectedCountry) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Loading...</h2>
          <p className="text-gray-600">Please wait while we load the country information.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60"
          style={{ backgroundImage: `url(${selectedCountry.imageURL})` }}
        ></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Study in {selectedCountry.name.charAt(0).toUpperCase() + selectedCountry.name.slice(1)}
          </h1>
          <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto">
            {selectedCountry.tagline}
          </p>
        </div>
      </section>

      {/* Main Content Sections */}
      <EligibilityRequirements eligibilityData={selectedCountry.eligibilityRequirements} />
      
      <ApplicationProcess processData={selectedCountry.applicationProcess} />
      
      <TuitionFees feesData={selectedCountry.tuitionFees} />
      
      {/* <CounselorContact /> */}
      
      <TopUniversities universitiesData={selectedCountry.topUniversities} />
      
      {/* <CostOfLiving livingCostData={selectedCountry.costOfLiving} /> */}
      <div className="p-10 w-full bg-[#FAEEDC] text-primary-dark rounded-lg">
            <h2 className="text-2xl font-bold mb-6 text-center text-brown-700">
              Book your FREE consultation with Certified Counsellors
            </h2>
            <ContactUsForm />
          </div>
    </div>
  );
}